define('taoQtiItem/qtiItem/core/interactions/SliderInteraction',['taoQtiItem/qtiItem/core/interactions/BlockInteraction'], function(BlockInteraction){
    var SliderInteraction = BlockInteraction.extend({
        qtiClass : 'sliderInteraction'
    });
    return SliderInteraction;
});



